"use client";

import viugoFilterLiveIcon from "@/assets/images/viugo/kbv-v16-filter-live-icon.svg";
import viugoFilterFlameIcon from "@/assets/images/viugo/kbv-v16-filter-flame-icon.svg";

export default function BongDaNetListFilterDate({
  dateOptions,
  selectedDate,
  onDateChange,
  isHotOnly,
  onToggleHot,
  liveLabel,
}) {
  const liveOpt = dateOptions.find((o) => o.type === "live");
  const restOptions = dateOptions.filter((o) => o.type !== "live");
  const liveText = liveLabel ?? liveOpt?.label ?? "Live";

  const pickDate = (value) => {
    onDateChange(value);
  };

  return (
    <div className="w-full overflow-hidden border-b-[2px] border-[var(--theme-primary)]">
      <div className="flex items-end">
        <ul
          className="m-0 list-none p-0 max-md:scrollbar-hide"
          style={{
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            alignItems: "stretch",
            overflowX: "auto",
            overflowY: "hidden",
            gap: "2px",
            WebkitOverflowScrolling: "touch",
            padding: 0,
            margin: 0,
          }}
        >
          {liveOpt && (
            <li
              className="rounded-t-[8px] px-[5px] py-[8px]"
              style={{
                flex: "0 0 auto",
                margin: 0,
                backgroundColor:
                  selectedDate === liveOpt.value && !isHotOnly
                    ? "var(--theme-tab-active)"
                    : "var(--theme-tab-inactive)",
              }}
            >
              <button
                type="button"
                onClick={() => pickDate(liveOpt.value)}
                className="flex items-center gap-[6px] whitespace-nowrap text-[12px] font-semibold md:text-[14px] md:font-normal"
                style={{
                  appearance: "none",
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  textDecoration: "none",
                  cursor: "pointer",
                  color:
                    selectedDate === liveOpt.value && !isHotOnly
                      ? "var(--theme-on-primary)"
                      : "var(--theme-tab-text)",
                }}
              >
                <img
                  src={viugoFilterLiveIcon}
                  width={10}
                  height={10}
                  className="inline-block animate-pulse"
                  alt=""
                  aria-hidden
                />
                <span>{liveText}</span>
              </button>
            </li>
          )}

          <li
            className="rounded-t-[8px] px-[10px] py-[8px]"
            style={{
              flex: "0 0 auto",
              margin: 0,
              backgroundColor: isHotOnly
                ? "var(--theme-tab-active)"
                : "var(--theme-tab-inactive)",
            }}
          >
            <button
              type="button"
              onClick={onToggleHot}
              className="flex items-center gap-[6px] whitespace-nowrap text-[12px] font-semibold md:text-[14px] md:font-normal"
              style={{
                appearance: "none",
                border: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
                textDecoration: "none",
                cursor: "pointer",
                color: isHotOnly
                  ? "var(--theme-on-primary)"
                  : "var(--theme-tab-text)",
              }}
            >
              <img
                src={viugoFilterFlameIcon}
                width={14}
                height={14}
                className="inline-block"
                alt=""
                aria-hidden
              />
              <span>Trận hot</span>
            </button>
          </li>

          {restOptions.map((opt) => {
            const isDateSelected = selectedDate === opt.value && !isHotOnly;
            return (
              <li
                key={opt.value}
                className="rounded-t-[8px] px-[10px] py-[8px]"
                style={{
                  flex: "0 0 auto",
                  margin: 0,
                  backgroundColor: isDateSelected
                    ? "var(--theme-tab-active)"
                    : "var(--theme-tab-inactive)",
                }}
              >
                <button
                  type="button"
                  onClick={() => pickDate(opt.value)}
                  className="block whitespace-nowrap text-[12px] font-semibold md:text-[14px] md:font-normal"
                  style={{
                    appearance: "none",
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    margin: 0,
                    textDecoration: "none",
                    cursor: "pointer",
                    color: isDateSelected
                      ? "var(--theme-on-primary)"
                      : "var(--theme-tab-text)",
                  }}
                >
                  {opt.label}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

